import { Component, OnInit, Input } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-preferred-role',
  templateUrl: './preferred-role.component.pug',
  styleUrls: ['./preferred-role.component.scss'],
  standalone: false
})
export class PreferredRoleComponent implements OnInit {
  @Input() data: any;

  constructor(
    private constant: ConstantsService,
    private permission: PermissionsService) { }

  ngOnInit(): void {
    this.data = {
      ...this.data,
      preferred_industry: this.constant.industryOptionsMap[this.data.preferred_industry] ?? this.data.preferred_industry
    }
  }

}
